import styled from '@emotion/styled';

export const SFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const SEyesReview = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: space-between;
`;
